import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RouterLink from 'react-router/lib/Link';
import oneLine from 'common-tags/lib/oneLine';
import suitcss from '../../../helpers/suitcss';
import connectUI from '../../basics/ui/UIConnector';

import {
  getHardwareTariffSelectedLink,
  getBundleSinglePaymentFee,
  getBundlePaymentFee,
} from '../../../helpers/entity';
import { shape as hardwareShape } from '../../../propTypes/hardware';
import { shape as tariffShape } from '../../../propTypes/tariff';
import { imageShape } from '../../../propTypes/media';
import imageSizes from '../../../config/imageSizes';

import Copy from '../../basics/text/TextCopy';
import Link from '../../basics/text/TextLink';
import Unit from '../../basics/text/TextUnit';
import Callout from '../../../containers/callout/Callout';
import MediaImage from '../../basics/media/MediaImage';
import MediaImageBackground from '../../basics/media/MediaImageBackground';

class HeaderItemBundle extends PureComponent {

  renderPrices() {
    const { hardware, tariff, ui } = this.props;
    const paymentFee = getBundlePaymentFee({ hardware, tariff });
    const singlePaymentFee = getBundleSinglePaymentFee({ hardware, tariff });
    const singlePaymentPrefix = tariff && oneLine`
      ${ui.guiSymbolPlus} ${ui.guiWordSingular}
    `;
    return (
      <div
        className={suitcss({
          componentName: 'HeaderStageItem',
          descendantName: 'prices',
        })}
      >
        <div
          className={suitcss({
            componentName: 'HeaderStageItem',
            descendantName: 'paymentFee',
            utilities: ['sHidden'],
          })}
        >
          <Unit
            size="m"
            price={paymentFee}
            postfix={ui.guiWordMonthlyAbbr}
          />
        </div>
        <div
          className={suitcss({
            componentName: 'HeaderStageItem',
            descendantName: 'paymentFee',
            utilities: ['mlHidden'],
          })}
        >
          <Unit
            size="s"
            price={paymentFee}
            postfix={ui.guiWordMonthlyAbbr}
          />
        </div>
        <div
          className={suitcss({
            componentName: 'HeaderStageItem',
            descendantName: 'singlePaymentFee',
          })}
        >
          <Unit
            price={singlePaymentFee}
            prefix={singlePaymentPrefix}
          />
        </div>
      </div>
    );
  }

  render() {
    const { copy, image, hardware, tariff, link, featured, ui } = this.props;
    const linkTo = link || getHardwareTariffSelectedLink({
      title: ui.hstGoToBundle,
      hardware,
      tariff,
    });
    const hardwareImage = {
      ...hardware.image,
      sizes: imageSizes[featured ? 'headerItemFeatured' : 'headerItem'],
    };
    const backgroundImage = {
      ...image,
      sizes: imageSizes[featured ? 'headerItemBackgroundFeatured' : 'headerItemBackground'],
    };
    return (
      <MediaImageBackground
        className={suitcss({
          componentName: 'HeaderStageItem',
          modifiers: [
            'typeBundle',
            featured && 'featured',
          ],
        })}
        {...backgroundImage}
        isLazy
      >
        <div
          className={suitcss({
            componentName: 'HeaderStageItem',
            descendantName: 'inner',
          })}
        >
          <div
            className={suitcss({
              componentName: 'HeaderStageItem',
              descendantName: 'image',
            })}
          >
            <RouterLink
              to={linkTo.url}
              target={linkTo.target}
              tabIndex="-1"
            >
              <MediaImage {...hardwareImage} isLazy />
            </RouterLink>
          </div>
          <div
            className={suitcss({
              componentName: 'HeaderStageItem',
              descendantName: 'content',
            })}
          >
            <div
              className={suitcss({
                componentName: 'HeaderStageItem',
                descendantName: 'copy',
              })}
            >
              <Copy raw embedded inverted>
                {copy}
              </Copy>
            </div>
            <div
              className={suitcss({
                componentName: 'HeaderStageItem',
                descendantName: 'subcontent',
              })}
            >
              {this.renderPrices()}
              <div
                className={suitcss({
                  componentName: 'HeaderStageItem',
                  descendantName: 'link',
                })}
              >
                <Link
                  to={linkTo.url}
                  asButton
                  buttonFilled
                  target={linkTo.target}
                >
                  {linkTo.title}
                </Link>
              </div>
            </div>
          </div>
          <Callout
            theme="badge"
            targets={[tariff.eid, hardware.eid, hardware.groupId]}
            inverted
          />
        </div>
      </MediaImageBackground>
    );
  }
}

HeaderItemBundle.propTypes = {
  copy: PropTypes.string,
  link: PropTypes.object,
  image: imageShape,
  tariff: tariffShape,
  hardware: hardwareShape,
  featured: PropTypes.bool,
  ui: PropTypes.shape({
    guiWordDetails: PropTypes.string.isRequired,
    guiWordMonthlyAbbr: PropTypes.string.isRequired,
    guiWordSingular: PropTypes.string.isRequired,
    guiSymbolPlus: PropTypes.string.isRequired,
    hstGoToBundle: PropTypes.string.isRequired,
  }),
};

HeaderItemBundle.defaultProps = {};

export default connectUI()(HeaderItemBundle);
